export enum SocialNetworkTypes {
    VK = 1
}